<div class="image-preview-container">
  <div class="close-icon">
    <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;" (click)="cancel()">close</mat-icon>
  </div>
  <div class="pagination"> {{activeIndex}} / {{images.length}}</div>
  <swiper (activeIndexChange)="onActiveIndexChange($event)" class="swiper-container" [navigation]="true" [pagination]="{type: 'bullets', clickable: true}" [navigation]="true"
    [slideActiveClass]="'active-bullet'">
    <ng-template swiperSlide *ngFor="let image of images">
      <div class="swiper-item">
        <img [src]="image.src">
      </div>
    </ng-template>
  </swiper>
</div>